export const variables = {
  promoToken: "16DA11D0-5D6E-EC11-AB22-0E32428CE4CB",
  connectHash: "c2l0ZWRydXBhbEBtYXN0ZXIuY29tfCUjUzF0M0BEcnVwYWwh",
};

export const ufSelect = [
  { id: 0, value: undefined, label: "Selecciona" },
  { id: 1, value: "ARI", label: "Arica y Parinacota" },
  { id: 2, value: "TAR", label: "Tarapacá" },
  { id: 3, value: "ANT", label: "Antofagasta" },
  { id: 4, value: "ATA", label: "Atacama" },
  { id: 5, value: "CQQ", label: "Coquimbo" },
  { id: 6, value: "VAP", label: "Valparaíso" },
  { id: 7, value: "SCL", label: "Metropolitana de Santiago" },
  { id: 8, value: "OHI", label: "del Libertador General Bernardo O'Higgins" },
  { id: 9, value: "MAU", label: "Maule" },
  { id: 10, value: "BIO", label: "Biobío" },
  { id: 11, value: "LAR", label: "La Araucanía" },
  { id: 12, value: "LRS", label: "Los Ríos" },
  { id: 13, value: "LLG", label: "Los Lagos" },
  { id: 14, value: "AYS", label: "Aysén del General Carlos Ibáñez del Campo" },
  { id: 15, value: "MAG", label: "Magallanes y de la Antártica Chilena" },
  { id: 16, value: "NUB", label: "Ñuble" },
];

export const genderSelect = [
  { id: 0, value: undefined, label: "Selecciona tu género" },
  { id: 1, value: "F", label: "Femenino" },
  { id: 2, value: "M", label: "Masculino" },
  { id: 3, value: "O", label: "Otros" },
  { id: 2, value: "N", label: "Prefiero no informar" },
];
